import { ItemCombobox } from '@models-global/model-combobox-item';
export const ENUM_USER_STATUS = {
  INACTIVE: 0,
  ACTIVE: 1
} as const;

export const ARRAY_USER_STATUS: ReadonlyArray<ItemCombobox> = [
  { value: ENUM_USER_STATUS.ACTIVE, text: 'Active' },
  { value: ENUM_USER_STATUS.INACTIVE, text: 'Inactive' }
];
